module.exports = "https://static.wmbcdn.com/uniweb/images/fa4e3132e055fc2c9d3b5a71a1c3f581.svg";